export default "__VITE_ASSET__p$5Ch6jV__"